import "./App.css";

import Wrapper from "./views/quizView/Wrapper";

import { createTheme, ThemeProvider } from "@mui/material";
import { themeconfig } from "./ThemeConfigs";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

function App() {
  const theme = createTheme(themeconfig);

  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        <Router>
          <Routes>
            {/* todo: add select screen */}
            <Route path="/" element={<Wrapper />} />
          </Routes>
        </Router>
        <div id="mediavine-settings" data-blocklist-all="1"></div>
      </div>
    </ThemeProvider>
  );
}

export default App;
